module.exports = __webpack_public_path__ + "img/Newbie_Sword_02_Classic.e98ddee5.png";